import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect, useCallback } from 'react';
import FormPopup from 'components/Operational/FormPopup';
import DetailedMediaSubform from '../MultiMediaUpload/DetailedMediaSubForm';
import COLOURS from 'utils/constants/colors';
import { generalSection, initialValues } from '../MultiMediaUpload/options';
import { PropTypes } from 'prop-types';
import { images } from 'utils/icons';
import Image from 'components/Image';
import Table from 'components/Table';
import { EvidenceSubForm } from './evidenceSubForm';
import { connect, useDispatch } from 'react-redux';
import API from 'services/api';
import { v4 } from 'uuid';
import { MEDIA_LOCATION } from 'services/media';
import evidenceCollected from 'images/icon_tick.svg';
import evidenceNotCollected from 'images/icon_cross.svg';
import { convertToUTCTime } from 'utils/time';
import { getPatrolTaskList } from 'containers/Pages/Tasks/PatrolTemplates/Selectors/patrolTemplateSelectors';
import cloneDeep from 'lodash/cloneDeep';
import { patrolPageActions } from 'containers/Pages/Tasks/Patrols';
import AddCircleOutlineSharpIcon from '@material-ui/icons/AddCircleOutlineSharp';
import { TASK_EVIDENCE_TYPE } from 'utils/constants/task';
import { isBase64, isJSON } from 'utils/checkImage';
import { fromJSON } from 'utils/helper/baseTasks';

const useStyles = makeStyles(() => ({
  labelContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10px',
  },
  img: {
    boxSizing: 'border-box',
    width: '10rem',
    height: '2.1rem',
  },
  header: {
    display: 'flex',
    width: '100%',
    background: COLOURS.DARK_GREY_01,
    justifyContent: 'flex-end',
    top: '0px',
    padding: '5px 20px',
  },
  cell: {
    width: '44%',
  },
  audioPlayer: {
    height: '400px',
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.9)',
  },
}));

const EvidenceForm = ({
  formProps, // formik props
  onChange, // sets the image in formik fields
  mediaType,
  noOfMediaFilesAllowed,
  checkpointDetails,
  evidenceTaskList,
  showEvidenceForm,
  userId,
  isPatrolled,
  isEvidenceCollected,
  openEvidenceDirectly,
  setEvidenceFormDirectly,
  evKey,
  evidenceFormKey,
  partialEvidenceUploaded,
}) => {
  const [showForm, setShowForm] = useState(showEvidenceForm);
  const [popUpData, setPopUpData] = useState([]);
  const formFields = generalSection();
  const [mediaForm, setMediaForm] = useState(false);
  const [evidenceKey, setKey] = useState();
  const [simpleEvidenceForm, setSimpleEvidenceForm] = useState(false);
  const classes = useStyles();
  const [updatedTask, setUpdatedTask] = useState();
  const [mediaArray, setMediaArray] = useState([]);

  // actions
  const dispatch = useDispatch();
  const dispatchPostEvidenceTask = useCallback(
    task => {
      dispatch(patrolPageActions.postEvidenceTask({ task }));
    },
    [dispatch],
  );

  // if this form needs to be open directly, then pass openEvidenceDirectly as truthy
  useEffect(() => {
    if (openEvidenceDirectly) {
      setShowForm(true);
      setKey(evKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEvidenceDirectly]);

  const closeForm = async () => {
    setShowForm(false);
    setEvidenceFormDirectly(false);
    setKey();
    // if you cancel, then completed is false and content should be null
    onChange({
      type: popUpData.type,
      evidence: checkpointDetails.evidence.map(m => ({
        ...m,
        completed: false,
        // contents: null,
      })),
      updatedCheckpointDetails: {
        ...checkpointDetails,
        evidence: checkpointDetails.evidence.map(m => ({
          ...m,
          completed: false,
          // contents: null,
        })),
        taskId: '',
      },
    });
  };

  const saveEvidence = async () => {
    try {
      setKey();
      if (mediaArray.length > 0) {
        for (let i = 0; i < mediaArray.length; i += 1) {
          const data = {
            isSecure: false,
            service: mediaArray[i].service,
            base64: mediaArray[i].base64,
          };
          API.uploadMediaItem({
            userId: mediaArray[i].userId,
            mediaId: mediaArray[i].mediaId,
            type: mediaArray[i].media[0].mediaType,
            data: data,
          });
        }
      }
      if (updatedTask?.task) {
        // const data = await API.postEvidenceTask(updatedTask?.task);
        dispatchPostEvidenceTask(updatedTask?.task);
        // tracks the uploaded form
        formProps.setFieldValue(
          'patrolledLocationTaskUploaded',
          evidenceFormKey,
        );
      }
      setShowForm(false);
      setEvidenceFormDirectly(false);
    } catch (error) {
      console.log(error);
    }
  };

  const closeMediaForm = () => {
    setMediaForm(false);
  };

  const closeSimpleEvidenceForm = () => {
    setSimpleEvidenceForm(false);
  };

  const onVirtualEvidenceChange = evidence => {
    const updatedEvidence = checkpointDetails?.evidence?.map(
      ev => [evidence].find(o => o.id === ev.id) || ev,
    );
    checkpointDetails.evidence = updatedEvidence;
    updateEvidenceInTask(evidence, checkpointDetails);
  };

  const updateEvidenceInTask = async (evidence, checkpointDetails) => {
    const task = cloneDeep(evidenceTaskList[checkpointDetails.taskId]);
    const newTaskUUID = v4();

    if (task) {
      Object.assign(task.tasks[0], {
        evidence: checkpointDetails.evidence,
        id: newTaskUUID,
        isTemplate: false,
        // taskId of the location becomes the template id for thew new created task
        templateId: checkpointDetails.taskId,
      });
      Object.assign(checkpointDetails, {
        taskId: newTaskUUID,
      });
      onChange({
        type: evidence.type,
        evidence: checkpointDetails.evidence,
        updatedCheckpointDetails: { ...checkpointDetails, taskId: newTaskUUID },
      });
      setUpdatedTask({ task: task, newTaskId: newTaskUUID });
    } else {
      Object.assign(updatedTask?.task?.tasks[0], {
        evidence: checkpointDetails.evidence,
      });
      onChange({
        type: evidence.type,
        evidence: evidence,
        updatedCheckpointDetails: checkpointDetails,
      });
      setUpdatedTask({
        task: updatedTask?.task,
      });
    }
  };

  const simpleEvidenceSubmit = evidence => {
    evidence.timestamp = convertToUTCTime({
      date: new Date(),
      timezone: 'UTC',
    });
    // transform the evidence if it is single select or multi select
    if (
      evidence.type === TASK_EVIDENCE_TYPE.OPTION_SINGLE.id ||
      evidence.type === TASK_EVIDENCE_TYPE.OPTION_MULTIPLE.id
    ) {
      evidence.contents = JSON.stringify(evidence.contents);
    }
    if (evidence.type === TASK_EVIDENCE_TYPE.SIGNATURE.id) {
      //construct and upload media array
      const media = [
        { url: evidence.contents, indexKey: 0, mediaType: 'IMAGE' },
      ];
      constructMediaUploadArray(media, evidence);
      closeSimpleEvidenceForm();
      return;
    }
    onVirtualEvidenceChange(evidence);
    closeSimpleEvidenceForm();
  };

  const constructMediaUploadArray = (media, data) => {
    const currentMediaObject = [];
    const mediaId = v4();
    const service = 'PATROL';
    const base64 = media[0].url;
    // check if the indexKey is existing in mediaArray
    const checkIfIndexExists = mediaArray.findIndex(
      f => f.indexKey === media[0].indexKey,
    );
    if (checkIfIndexExists !== -1) {
      mediaArray[checkIfIndexExists].base64 = media[0].url;
      mediaArray[checkIfIndexExists].media = media;
      return;
    }
    currentMediaObject.push({
      mediaId,
      userId,
      service,
      base64,
      media,
      url: `${MEDIA_LOCATION}/${userId}/${mediaId}/${media[0].mediaType}`,
      evidenceId: data.id,
      indexKey: mediaArray.length,
    });
    data.contents = `${MEDIA_LOCATION}/${userId}/${mediaId}/${media[0].mediaType}`;
    data.completed = true;
    data.mediaType =
      data.mediaType === TASK_EVIDENCE_TYPE.SIGNATURE.id
        ? 'IMAGE'
        : data.mediaType;
    data.timestamp = convertToUTCTime({
      date: new Date(),
      timezone: 'UTC',
    });
    setMediaArray([...mediaArray, ...currentMediaObject]);
    onVirtualEvidenceChange(data);
  };

  const data =
    checkpointDetails.evidence.length > 0 &&
    checkpointDetails.evidence.map(evidence => ({
      allowDelete: false,
      allowEdit: true,
      rowData: {
        type: evidence.type,
        description: evidence.description,
      },
      rawData: { ...evidence },
    }));
  const evidenceUpload = [
    { headerName: 'Type' },
    { headerName: 'Description' },
  ];

  const openEditForm = t => {
    const isJSONString = isJSON(t.contents);
    const isBase64Image = isBase64(t.contents);

    const contents = t.contents
      ? isBase64Image
        ? t.contents
        : isJSONString
        ? fromJSON(t.contents)
        : t.contents
      : '';
    t['mediaType'] = t.type;
    if (t.type === 'IMAGE' || t.type === 'AUDIO' || t.type === 'VIDEO') {
      setMediaForm(true);
      const editMediaInfo = mediaArray.find(media => media.evidenceId === t.id);
      if (editMediaInfo) {
        setPopUpData([
          {
            ...editMediaInfo.media[0],
            indexKey: editMediaInfo.indexKey,
          },
        ]);
      } else {
        setPopUpData(t);
      }
    } else if (
      t.type === TASK_EVIDENCE_TYPE.SIGNATURE.id &&
      mediaArray.length > 0
    ) {
      const editMediaInfo = mediaArray.find(media => media.evidenceId === t.id);
      setPopUpData({
        ...t,
        ...(contents && { contents: editMediaInfo.media[0].url }),
      });
      setSimpleEvidenceForm(true);
    } else {
      setPopUpData({ ...t, ...(contents && { contents }) });
      setSimpleEvidenceForm(true);
    }
    setShowForm(true);
  };
  const showform = key => {
    setKey(key);
    setShowForm(true);
  };

  const isFirstPointPatrolled = formProps => {
    // get all checkpoints
    const cp = formProps?.values?.checkpoints;
    // check if the first cp has been patrolled
    const firstPoint = cp.find(f => f?.seqNumber === 1);

    if (firstPoint?.patrolled) {
      return false; // dont disable
    }
    return true;
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.labelContainer}>
          {isPatrolled ? (
            <Image
              src={
                isEvidenceCollected ? evidenceCollected : evidenceNotCollected
              }
              className={classes.img}
            />
          ) : (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Image
                title={mediaType}
                src={images.addMedia.default}
                onClick={() => showform(evidenceFormKey)}
                className={classes.img}
                disabled={
                  evidenceFormKey === 1
                    ? false
                    : isFirstPointPatrolled(formProps)
                } // only enable when first point is patrolled
                text={`${
                  partialEvidenceUploaded || isEvidenceCollected
                    ? 'Edit'
                    : 'Add'
                } Evidence`}
                icon={<AddCircleOutlineSharpIcon />}
              />
              {(partialEvidenceUploaded || isEvidenceCollected) && (
                <Image
                  src={
                    isEvidenceCollected
                      ? evidenceCollected
                      : evidenceNotCollected
                  }
                  className={classes.img}
                />
              )}
            </div>
          )}
        </div>
        {showForm && evidenceFormKey === evidenceKey && (
          <FormPopup
            headerTitle={'Collect Evidence'}
            closePopup={closeForm}
            isSaveRequired={true}
            onSaveClick={saveEvidence}
            form={
              <Table
                allowDeleteRow={false}
                allowEditRow={true}
                columns={evidenceUpload}
                data={data}
                showMediaInPortal={false}
                onEdit={t => openEditForm(t)}
              />
            }
          />
        )}
        {simpleEvidenceForm && (
          <FormPopup
            headerTitle={'Provide Evidence'}
            closePopup={closeSimpleEvidenceForm}
            form={
              <EvidenceSubForm
                type={popUpData.type}
                description={popUpData.description}
                cancel={closeSimpleEvidenceForm}
                submit={vals => simpleEvidenceSubmit(vals)}
                formProps={formProps}
                data={popUpData}
              />
            }
          />
        )}

        {mediaForm && (
          <FormPopup
            headerTitle={
              popUpData.mediaType === 'AUDIO'
                ? 'Add Detailed Audio'
                : 'Add Detailed Image'
            }
            closePopup={closeMediaForm}
            form={
              <DetailedMediaSubform
                fields={formFields}
                defaultValues={initialValues}
                editValues={popUpData}
                cellClassName={classes.cell}
                cancel={closeMediaForm}
                submit={media => {
                  setMediaForm(false);
                  constructMediaUploadArray(media, popUpData);
                }}
                requiredFields={['surfaces']}
                label={popUpData?.mediaType.toLowerCase()}
                mediaType={[popUpData.mediaType]}
                formProps={formProps}
                noOfMediaFilesAllowed={noOfMediaFilesAllowed}
              />
            }
          />
        )}
      </div>
    </>
  );
};

EvidenceForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  formProps: PropTypes.object,
  value: PropTypes.array,
  mediaLabel: PropTypes.string,
  mediaType: PropTypes.array,
  disabled: PropTypes.bool,
  noOfMediaFilesAllowed: PropTypes.number,
  evKey: PropTypes.number,
  evidenceFormKey: PropTypes.number,
  evidenceTaskList: PropTypes.object,
  userId: PropTypes.string,
  isPatrolled: PropTypes.bool,
  isEvidenceCollected: PropTypes.bool,
  checkpointDetails: PropTypes.object,
  showEvidenceForm: PropTypes.bool,
  openEvidenceDirectly: PropTypes.bool,
  partialEvidenceUploaded: PropTypes.bool,
  setEvidenceFormDirectly: PropTypes.func,
};

EvidenceForm.defaultProps = {
  // mediaType: ['IMAGE', 'AUDIO'], // can be ['IMAGE','AUDIO']
};

const mapStateToProps = state => ({
  evidenceTaskList: getPatrolTaskList(state),
  userId: state.user.general.id,
});

export default connect(mapStateToProps, null)(EvidenceForm);
